<form #addressForm="ngForm">
    <div class="position-relative">
        <div class="mb-3">
            <input
                #addressInputRef
                type="text"
                class="form-control"
                [ngClass]="{ 'form-control-border': hasBorder }"
                id="addressInput"
                name="addressInput"
                [placeholder]="'ENTER_ADDRESS_PLACEHOLDER' | translate"
                [ngModel]="location.address"
                (input)="onAddressInput()"
                (keydown)="onKeyDown($event)"
                (focus)="onFocusInput()"
                (blur)="onBlurInput()"
                [disabled]="disabled"
                [required]="required"
                data-1p-ignore
                data-lpignore="true"
                data-protonpass-ignore="true"
                data-bwignore="true"
                autocomplete="off" />
            <div class="dropdown-container" #dropdownContainerRef></div>
        </div>
    </div>
</form>

<ng-template #dropdownListRef>
    <ul class="list-group w-100 shadow-sm z-2">
        <li
            class="list-group-item list-group-item-action d-flex align-items-center p-3 pointer"
            *ngFor="let prediction of predictions; let i = index"
            [class.activePrediction]="i === activeIndex"
            (click)="onSelectPlace(prediction)">
            <div class="me-3">
                <fa-icon [icon]="['fal', 'map-marker-alt']" class="text-primary"></fa-icon>
            </div>
            <div>
                <span>{{ prediction.placePrediction.text.toString() }}</span>
            </div>
        </li>
    </ul>
</ng-template>
